import { crremUrls } from "features/energy-analysis-dashboard/api/urls";
import { customApiCall } from "utils/axios";

import { emptyCrremDashboardPayload, parseCrremDashboardPayload } from "../lib/parseCrremDashboardApi";
import { parseCrremPathwayIncomplete, readAxiosErrorData } from "../lib/parseCrremPathwayApi";

export const fetchCrremDashboardScenarios = async (projectId: string) => {
  try {
    return parseCrremDashboardPayload(await customApiCall.get({ url: crremUrls.allScenarios(projectId) }));
  } catch (error) {
    const incomplete = parseCrremPathwayIncomplete(readAxiosErrorData(error));
    if (incomplete) return { ...emptyCrremDashboardPayload(), missing: incomplete.missing };
    throw error;
  }
};

export const downloadCrremSubsetTemplate = (projectId: string, errorMessage?: string) =>
  customApiCall.download({
    errorMessage,
    fileName: `crrem-subset-${projectId}.xlsx`,
    url: crremUrls.subsetDownload(projectId),
  });

export const revertCrremSubsetOverrides = (projectId: string) =>
  customApiCall.delete({ url: crremUrls.subsetOverrides(projectId) });

export const uploadCrremSubset = (projectId: string, file: File) =>
  customApiCall.upload({ data: { file }, url: crremUrls.subsetUpload(projectId) });
